var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3325 21.3338V14.6671H15.6658V21.3338C15.6658 22.0671 16.2658 22.6671 16.9992 22.6671H20.9992C21.7325 22.6671 22.3325 22.0671 22.3325 21.3338V12.0004H24.5992C25.2125 12.0004 25.5058 11.2404 25.0392 10.8404L13.8925 0.800449C13.3858 0.347116 12.6125 0.347116 12.1058 0.800449L0.959154 10.8404C0.505821 11.2404 0.785821 12.0004 1.39915 12.0004H3.66582V21.3338C3.66582 22.0671 4.26582 22.6671 4.99915 22.6671H8.99915C9.73249 22.6671 10.3325 22.0671 10.3325 21.3338Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboardWhite.29181d1a00a1145a15fed3d7ca364c49.svg";
export { ForwardRef as ReactComponent };